import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const IntegrationsService = {
    list: () => axios.post(API_KEEPER + "/integrations/laneintegrations/partner/list", {}).then(({data}) => data).catch((err) => { throw err }),

    updateStatus: (data) => axios.post(API_KEEPER + "/integrations/laneintegrations/api/partner/updatestatus", data).catch((err) => { throw err }),

    imageRequest: () => axios.get(API_KEEPER + "/interligation/configuration/integrationImageRequest").then(({data}) => data).catch((err) => { throw err }),

    imageRequestPost: (data) => axios.post(API_KEEPER + "/interligation/configuration/integrationImageRequest", data).catch((err) => { throw err }),

    getIntegrations: () => axios.get(API_KEEPER + "/integrations/web/getIntegrations").then(({data}) => data).catch((err) => { throw err }),
};

export default IntegrationsService;
